export default "__VITE_ASSET__D2hXgpO1__"